import { render, staticRenderFns } from "./ColumnActions.vue.js?vue&type=template&id=f188fe4c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnActions.vue?vue&type=template&id=f188fe4c"
import script from "./ColumnActions.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnActions.vue?vue&type=script&lang=js"
export * from "./ColumnActions.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ColumnActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports